import type { Processo } from "../processi";

export const processiFixtures: Processo[] = [
  {
    id: "antifrode",
    nome: "Antifrode",
    descrizione: "Verifica guidata dei principali segnali di rischio nelle pratiche e nei documenti.",
    stato: "Pronto per l'uso",
    aggiornatoIl: "oggi",
    passaggi: ["Raccogliere i documenti della pratica", "Controllare i dati e le incongruenze", "Preparare il riepilogo dei segnali da verificare"],
  },
  {
    id: "verifica-documenti",
    nome: "Verifica documenti",
    descrizione: "Controllo dimostrativo della completezza dei documenti associati a una pratica.",
    stato: "In preparazione",
    aggiornatoIl: "ieri",
    passaggi: ["Selezionare la pratica", "Confrontare i documenti richiesti", "Segnalare ciò che manca"],
  },
  {
    id: "scadenze",
    nome: "Controllo scadenze",
    descrizione: "Riepilogo simulato delle prossime scadenze e delle attività da non dimenticare.",
    stato: "Pronto per l'uso",
    aggiornatoIl: "16 ott 2026",
    passaggi: ["Ordinare le scadenze", "Evidenziare le urgenze", "Condividere le prossime attività"],
  },
];
